'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const HouseIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="HouseIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_278_10012)">
          <path
            d="M3.66992 12.98V21.8C3.66992 22.3412 4.10872 22.78 4.64992 22.78H9.05992C9.33052 22.78 9.54992 22.5606 9.54992 22.29V18.37C9.54992 16.484 11.5916 15.3052 13.2249 16.2482C13.9829 16.6859 14.4499 17.4947 14.4499 18.37V22.29C14.4499 22.5606 14.6693 22.78 14.9399 22.78H19.3499C19.8912 22.78 20.3299 22.3413 20.3299 21.8V13.47"
            stroke={sx?.color || '#3D517B8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.72998 12.49L12 1.22L23.27 12.49"
            stroke={sx?.color || '#3D517B8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

HouseIcon.propTypes = {
  sx: PropTypes.object
}
